import { makeStyles } from '@material-ui/core/styles';
import { Button, TextField } from '@material-ui/core';
import { useState } from 'react';
import { createFundraisingTransactionQuickSearchFilter } from 'src/lib/QueryBuilderHelper';
import {
  getEntitiesAction,
  setFilters,
  setQuickSearch,
} from 'src/redux/actions/querybuilderActions';
import { ENTITIES, QuerbuilderPayloadFilters } from 'src/models/QuerybuilderModel';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { FORM, FORM_STATUS } from 'src/constants/Form';
import { resetSelections } from 'src/redux/actions/selectionActions';
import { t } from 'src/lib/language';
// eslint-disable-next-line import/no-extraneous-dependencies
import { ContactQuickSearch, QuickSearchPayload } from 'src/models/QuickSearchModel';

const useStyles = makeStyles((theme) => ({
  datagridQuickSearch: {
    width: '100%',
    border: '1px solid #eeeeee',
    borderTop: 'none',
    padding: theme.spacing(1),
  },
  datagridQuickSearchContainer: {
    maxWidth: '1080px',
    width: '100%',
  },
  datagridQuickSearchClear: {
    color: theme.palette.primary.main,
    '&:Hover': {
      textDecoration: 'underline',
      color: theme.palette.primary.light,
      cursor: 'pointer',
    },
  },
  datagridSearchClose: {
    lineHeight: '20px',
    height: '20px',
    textAlign: 'center',
    margin: 'auto auto',
    color: theme.palette.primary.main,
    '&:hover': {
      color: theme.palette.primary.light,
      cursor: 'pointer',
      textDecoration: 'underline',
    },
  },
  row: {
    display: 'flex',
    alignItems: 'baseline',
    flexDirection: 'row',
    gap: '10px',
    marginTop: '-16px',
  },
  text: {
    padding: theme.spacing(0, 1),
  },
}));

interface Props {
  entity: ENTITIES,
}

const DatagridQuickSearchFundraisingTransactions = (props: Props) => {
  const classes = useStyles();
  const { entity } = props;

  const getfundraisingId = () => {
    const pathSegments = window.location.pathname.split('/');
    return pathSegments[pathSegments.length - 1];
  };

  const dispatch = useAppDispatch();

  const loading = useSelector(
    (state: Store) => (state.formStatus[FORM.query_builder] === FORM_STATUS.processing),
  );
  const lang = useSelector((state: Store) => state.language.language);

  const storedQuickSearch =
    useSelector(
      (state: Store) => (
        state.quickSearch && state.quickSearch[entity] as ContactQuickSearch
      )
        || {
          term: '',
        } as ContactQuickSearch,
    );

  const [fundraisingQuickSearch, setFundraisingQuickSearch] = useState(storedQuickSearch);

  const getQuickSearch = () => {
    const filters
      = createFundraisingTransactionQuickSearchFilter(fundraisingQuickSearch, getfundraisingId());
    dispatch(resetSelections({ entity }));
    dispatch(setFilters({
      entity,
      filters,
    } as QuerbuilderPayloadFilters));
    dispatch(setQuickSearch({
      entity,
      quicksearch: fundraisingQuickSearch,
    } as QuickSearchPayload));
    dispatch(getEntitiesAction(entity));
  };

  const handleKeyDown = (e: { key: string; }) => {
    if (e.key === 'Enter') {
      getQuickSearch();
    }
  };

  const clearFilter = () => {
    dispatch(setFilters({
      entity,
      filters:
        createFundraisingTransactionQuickSearchFilter({ term: '' } as ContactQuickSearch, getfundraisingId()),
    } as QuerbuilderPayloadFilters));

    const defaultQuickSearch = {
      term: '',
    } as ContactQuickSearch;

    setFundraisingQuickSearch(defaultQuickSearch);

    dispatch(setQuickSearch({
      entity,
      quicksearch: defaultQuickSearch,
    } as QuickSearchPayload));

    dispatch(getEntitiesAction(entity));
  };

  const onChange = (field: string, value:any) => {
    setFundraisingQuickSearch({
      ...fundraisingQuickSearch,
      [field]: value,
    });
  };

  return (
    <div className={classes.datagridQuickSearch}>
      <div className={classes.datagridQuickSearchContainer}>
        <div className={classes.row}>
          <div style={{ width: '50%', display: 'flex' }}>
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              margin="normal"
              label={t(lang, 'menus.quick_search_term')}
              onChange={(e:any) => onChange('term', e.target.value as string)}
              onKeyDown={handleKeyDown}
              value={fundraisingQuickSearch.term} />
          </div>
          <Button
            variant="contained"
            color="primary"
            style={{
              marginLeft: '8px',
              marginTop: '8px',
            }}
            onClick={getQuickSearch}
            disabled={loading}>
            {t(lang, 'menus.quick_search')}
          </Button>
          <div
            className={classes.datagridQuickSearchClear}
            onClick={() => clearFilter()}>
            {t(lang, 'menus.clear_filter')}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DatagridQuickSearchFundraisingTransactions;
